var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8701 16.7207L14.8701 2.93945C14.8701 1.77634 13.9239 0.830078 12.7607 0.830078L2.91699 0.830078C1.75388 0.830078 0.807617 1.77634 0.807617 2.93945L0.807616 16.7207C0.807616 17.8838 1.75388 18.8301 2.91699 18.8301L12.7607 18.8301C13.9239 18.8301 14.8701 17.8838 14.8701 16.7207ZM2.91699 17.4238C2.52929 17.4238 2.21387 17.1084 2.21387 16.7207L2.21387 2.93945C2.21387 2.55175 2.52929 2.23633 2.91699 2.23633L12.7607 2.23633C13.1484 2.23633 13.4639 2.55175 13.4639 2.93945L13.4639 16.7207C13.4639 17.1084 13.1484 17.4238 12.7607 17.4238L2.91699 17.4238Z",
    fill: "#677C95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletVertical);
export default __webpack_public_path__ + "static/media/tablet-vertical.68aa2926da4b613aec87bd5016a1fffa.svg";
export { ForwardRef as ReactComponent };